module.exports = __webpack_public_path__ + "static/media/company-law.b5c2c33c.png";